export default __webpack_public_path__ + "static/media/VERTICAL_ORG_53.a01a8bb2.png";